import React from 'react';

export const PhaseNavigationButtons = ({
    phaseStepBackButtonText,
    showPhaseStepBackButton,
    translations,
    onPhaseStepBackButtonClick,
    onAutoPickProductsButtonClick,
    onContinueButtonClick,
    hasPhaseStepMealsCompleted,
    hasPickedProductExceedAvailability,
    isEditMode,
    continueButtonText,
    onCompleteEditationButtonClick,
    isAllPhasesComplete,
}) => (
    <div className="phase-navigation-buttons-wrapper">
        <div>
            {showPhaseStepBackButton && (
                <button
                    className="btn btn--md btn-sm--xl btn--outline-purple btn--white phase-navigation-button phase-navigation-button--back"
                    onClick={onPhaseStepBackButtonClick}
                >
                    {/* prettier-ignore */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="15" viewBox="0 0 10 15"><g><g transform="rotate(-270 5.5 7.5)"><g><g><path fill="none" stroke="#6b3389" strokeMiterlimit="20" strokeWidth="2" d="M-1.25 4.5v0l6.75 6.75v0l6.75-6.75v0"/></g></g></g></g></svg>
                    <span>{phaseStepBackButtonText}</span>
                </button>
            )}
        </div>
        <div className="phase-navigation-buttons-continue-block">
            <button
                className="btn btn--md btn-sm--xl btn--outline-green btn--outline-green btn--white phase-navigation-button autopick-button"
                onClick={onAutoPickProductsButtonClick}
            >
                <span>{translations['eshop.configurator.action.prefill_step_as_recommended']}</span>
            </button>
            {isEditMode ? (
                <button
                    className={`btn btn--md btn-sm--xl btn--green diet-calculation-button diet-calculation-send-offer${
                        !isAllPhasesComplete || hasPickedProductExceedAvailability
                            ? ' diet-calculation-button--disabled'
                            : ''
                    }`}
                    onClick={
                        !isAllPhasesComplete || hasPickedProductExceedAvailability
                            ? undefined
                            : onCompleteEditationButtonClick
                    }
                    data-tip={translations['eshop.configurator.action.complete_diet_editation_disabled']}
                    data-tip-disable={isAllPhasesComplete && !hasPickedProductExceedAvailability}
                >
                    <span>{translations['eshop.configurator.action.complete_diet_editation']}</span>
                </button>
            ) : (
                <button
                    className="btn btn--md btn-sm--xl btn--green diet-calculation-send-offer"
                    onClick={onContinueButtonClick}
                    disabled={!hasPhaseStepMealsCompleted || hasPickedProductExceedAvailability}
                >
                    <span>{continueButtonText}</span>
                </button>
            )}
        </div>
    </div>
);
